module.exports = __webpack_public_path__ + "assets/edbb9fef59acbdd2c3fcf31049c8419d.png";